//Components
import { Likert as LikertComponent } from "@mobi/ds"

//Style
import "./index.scss"
//Hooks
import useLikert from "./useLikert"

const Likert = ({ ga = false, onSubmit: onSubmitProps, ...rest }) => {
	const { onSubmit } = useLikert({ onSubmit: onSubmitProps })

	const handleCallback = (data) => {
		const payload = {
			description: data.description,
			rating: data.experience,
			improvements: data.options.length === 0 ? [] : [data.options]
		}
		onSubmit(payload, ga)
	}

	const optionsList = [
		{
			id: "opt1",
			label: "calculadora de parcelas",
			value: "SIMULATOR"
		},
		{
			id: "opt2",
			label: "formulário",
			value: "FORM"
		},
		{
			id: "opt3",
			label: "não sei o que fazer agora",
			value: "NOT_KNOW_WHAT_TO_DO"
		},
		{
			id: "opt4",
			label: "outros",
			value: "OTHER"
		}
	]

	return (
		<LikertComponent
			options={optionsList}
			dataCallback={handleCallback}
			{...rest}
		/>
	)
}

export default Likert
